import React from 'react';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import { withStyles } from 'tss-react/mui';
import Paper from '@mui/material/Paper';
import { data as services } from '@lba-dev/package.local-globals/services';

import { mapStateToProps } from './functions';
import { styles } from './utils';
import Selector from '../../components/Utils/Selector';

const SelectUsers = ({
  classes,
  users,
  selectedUsers,
  selectedServices,
  selectUserOrService,
  generateUserList,
  generateChips
}) =>
  <Paper className={classes.paper}>
    <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        <Selector
          multiple
          value={[]}
          handleChange={([v]) => selectUserOrService(v)}
          title="Choisir un utilisateur"
        >
          {services.map(generateUserList)}
        </Selector>
      </Grid>
      <Grid item xs={12} sm={8}>
        <div className={classes.chips}>
          {generateChips(selectedServices, services, 'secondary')}
        </div>
        <div className={classes.chips}>
          {generateChips(selectedUsers, users, 'primary')}
        </div>
      </Grid>
    </Grid>
  </Paper>;

export default connect(mapStateToProps)(withStyles(SelectUsers, styles));
